import "./cart.css";
import Path from "../../components/path/path";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Cart = ({ Data, SetData }) => {
  const cartRawData = Data.Cart;

  const handleIncrement = (index) => {
    const updatedData = { ...Data };
    updatedData.Cart = updatedData.Cart.map((item, i) =>
      i === index ? { ...item, productQuantity: (item.productQuantity || 0) + 1 } : item
    );
    SetData(updatedData);
  };

  const handleDecrement = (index) => {
    const item = Data.Cart[index];
    const minQty = item.mode === 'wholesale' ? (item.wholesaleMinQty || 1) : 1;
    
    if (item.productQuantity > minQty) {
      const updatedData = { ...Data };
      updatedData.Cart = updatedData.Cart.map((cartItem, i) =>
        i === index ? { ...cartItem, productQuantity: cartItem.productQuantity - 1 } : cartItem
      );
      SetData(updatedData);
    }
  };

  const handleChange = (index, event) => {
    const value = event.target.value;
    // Allow empty string for user to type, will be validated on blur
    if (value === '' || /^\d+$/.test(value)) {
      const updatedData = { ...Data };
      updatedData.Cart = updatedData.Cart.map((item, i) =>
        i === index ? { ...item, productQuantity: value === '' ? '' : parseInt(value, 10) } : item
      );
      SetData(updatedData);
    }
  };

  const handleBlur = (index, event) => {
    let value = parseInt(event.target.value, 10);
    const item = Data.Cart[index];
    
    // Get minimum quantity based on mode
    const minQty = item.mode === 'wholesale' ? (item.wholesaleMinQty || 1) : 1;
    
    // Validate and enforce minimum
    if (isNaN(value) || value < minQty) {
      value = minQty;
    }
    
    const updatedData = { ...Data };
    updatedData.Cart = updatedData.Cart.map((cartItem, i) =>
      i === index ? { ...cartItem, productQuantity: value } : cartItem
    );
    SetData(updatedData);
  };

  const handleRemoveClick = (index, item) => {
    SetData((prevData) => {
      const updatedData = { ...prevData };
      updatedData.Cart = updatedData.Cart.filter((_, i) => i !== index);
      const placeDataKey = item.productPosition;
      // Safety check: Ensure the category exists in Home data before mapping
      if (updatedData.Home && updatedData.Home[placeDataKey]) {
        updatedData.Home[placeDataKey] = updatedData.Home[placeDataKey].map(
          (subItem) => ({
            ...subItem,
            cardActive: subItem.id === item.id ? "" : subItem.cardActive
          })
        );
      }
      return updatedData;
    });
  };

  const handleClick = () => {
    SetData((prevData) => {
      const resetHome = { ...prevData.Home };
      // Helper to reset active state
      const resetActive = (arr) => arr ? arr.map(item => ({ ...item, cardActive: "" })) : [];

      resetHome.Component2 = resetActive(resetHome.Component2);
      resetHome.Component4 = resetActive(resetHome.Component4);
      resetHome.Component6 = resetActive(resetHome.Component6);

      return {
        ...prevData,
        Cart: [],
        Home: resetHome
      };
    });
  };

  const subtotal = cartRawData.reduce(
    (acc, pro) => acc + (Number(pro.productQuantity) || 0) * pro.productPrice,
    0
  );
  return (
    <>
      <Helmet>
        <title>ThinkTwiceOnline Store | Cart</title>
        <meta name="description" content="ThinkTwiceOnline Store | Cart" />
      </Helmet>
      <section id="cart">
        <div className="container my-5">
          <Path pathName={"Cart"} />
          <div className="row mt-5">
            <div className="col-10 m-0 m-auto">
              <table width="100%">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      width="25%"
                      className="text-center py-3 px-4 px-lg-0"
                    >
                      Product
                    </th>
                    <th
                      scope="col"
                      width="25%"
                      className="text-center py-3 px-2 px-lg-0"
                    >
                      Price
                    </th>
                    <th
                      scope="col"
                      width="25%"
                      className="text-center py-3 px-2 px-lg-0"
                    >
                      Quantity
                    </th>
                    <th
                      scope="col"
                      width="15%"
                      className="text-center py-3 px-2 px-lg-0"
                    >
                      Delet
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <br />
                  {cartRawData.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center py-1">
                        <div>
                          <img src={item.productImg} alt="#" width="30%" />
                          <span className="d-block d-lg-inline">
                            {item.productName}
                          </span>
                          {item.variantName && (
                            <small className="d-block text-muted">{item.variantName}</small>
                          )}
                          {item.mode === 'wholesale' && (
                            <span className="badge bg-warning text-dark ms-2">Wholesale</span>
                          )}
                        </div>
                      </td>
                      <td className="text-center py-1">KSh {item.productPrice}</td>
                      <td className="text-center py-1">
                        <div className="quantity-controls d-flex align-items-center justify-content-center gap-2">
                          <button 
                            type="button"
                            className="qty-btn"
                            onClick={() => handleDecrement(index)}
                          >
                            -
                          </button>
                          <input
                            type="number"
                            className="qty-input"
                            value={item.productQuantity}
                            onChange={(e) => handleChange(index, e)}
                            onBlur={(e) => handleBlur(index, e)}
                            min={item.mode === 'wholesale' ? (item.wholesaleMinQty || 1) : 1}
                          />
                          <button 
                            type="button"
                            className="qty-btn"
                            onClick={() => handleIncrement(index)}
                          >
                            +
                          </button>
                        </div>
                        {item.mode === 'wholesale' && item.wholesaleMinQty > 1 && (
                          <small className="text-muted d-block mt-1">
                            Min: {item.wholesaleMinQty}
                          </small>
                        )}
                      </td>
                      <td className="text-center py-1">
                        <i
                          className="bi bi-x-lg"
                          onClick={() => handleRemoveClick(index, item)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row mt-4 btn_cus mx-4 mx-lg-0">
            <div className="col-6 m-0 m-auto d-flex justify-content-center">
              <Link
                to="#"
                className="py-2 py-lg-2 px-3 px-lg-4"
                onClick={handleClick}
              >
                Update Cart
              </Link>
            </div>
            <div className="col-6 m-0 m-auto d-flex justify-content-center">
              <Link to="/home" className="py-2 py-lg-2 px-3 px-lg-4">
                Return To Shop
              </Link>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-10 col-lg-4 py-3 px-4 m-0 m-auto cartBox mt-4 mt-lg-0">
              <div>
                <h5>Cart Total</h5>
                <div>
                  <div className="d-flex justify-content-between mt-4 pb-3 cartBoxDeeb">
                    <span>Subtotal:</span>
                    <span className="cusSpan">KSh {subtotal.toLocaleString()}</span>
                  </div>
                  <div className="d-flex justify-content-between mt-4 pb-3">
                    <span>Total:</span>
                    <span className="cusSpan">KSh {subtotal.toLocaleString()}</span>
                  </div>
                  <Link to="/checkout" className="checkout-btn">
                    Proceed to Checkout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cart;
